import React from 'react';
import PropTypes from 'prop-types';
import { formatUrl } from 'url-lib';
import gettext from '@eb/gettext';
import has from 'lodash/has';
import { setWindowLocation } from '@eb/http';

import { withMainControls } from '@eb/eds-structure';
import { TYPE_ERROR } from '@eb/eds-notification';
import { AlertChunky } from '@eb/eds-iconography';

import PageHeader from '../../components/PageHeader';
import ResetPasswordForm from '../../components/newForms/ResetPasswordForm';
import SplitContainer from '../../connectedComponents/SplitContainer';

import {
    SET_PASSWORD_FORM,
    PASSWORD_SET_TOKEN,
    INVALID_RESET_TOKEN,
    RESET_PASSWORD_PATH,
} from '../../constants';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/RESET_PASSWORD_PATH
 */
class ResetPasswordPage extends React.Component {
    static propTypes = {
        handleResetPassword: PropTypes.func,
        locale: PropTypes.string,
        hideMainNotification: PropTypes.func,
        addMainNotification: PropTypes.func,
    };

    _handleShowNotification = (error) => {
        const { addMainNotification } = this.props;

        /*Limit the call to addMainNotification to only if
        a notification hasn't been shown since last submit.*/
        if (addMainNotification && !this._hasNotification) {
            addMainNotification({
                type: TYPE_ERROR,
                children: error,
                iconType: <AlertChunky />,
            });

            this._hasNotification = true;
        }
    };

    _handleClearNotification = () => {
        const { hideMainNotification } = this.props;

        this._hasNotification = false;

        hideMainNotification && hideMainNotification();
    };

    _handleSubmit = (formData) => {
        const { clearAuthNotification, handleResetPassword } = this.props;
        // clear notification everytime form is submitted
        if (clearAuthNotification) {
            clearAuthNotification();
        }

        return handleResetPassword(formData);
    };

    render() {
        const {
            locale,
            router: {
                location: { query },
            },
            clearAuthNotification,
            usesNewStyles,
            form,
            recaptcha2PublicKey,
            showCaptcha,
            fp,
        } = this.props;

        const pageHeaderProps = {
            headerText: gettext('Update your password'),
            subtitleText: gettext('Enter your new password below'),
            usesNewStyles,
        };
        const buttonCTA = gettext('Update password');
        let syncErrors;

        if (form[SET_PASSWORD_FORM]) {
            syncErrors = form[SET_PASSWORD_FORM].syncErrors;
        }

        // If the query not includes parameters to reset the password, we redirect to home page with error
        if (!has(query, PASSWORD_SET_TOKEN)) {
            setWindowLocation(
                formatUrl(RESET_PASSWORD_PATH, {
                    [INVALID_RESET_TOKEN]: 1,
                }),
            );
        }

        return (
            <SplitContainer
                shouldShowSecondaryPanel={usesNewStyles}
                usesNewStyles={usesNewStyles}
                header={<PageHeader {...pageHeaderProps} />}
            >
                <ResetPasswordForm
                    formErrors={syncErrors}
                    buttonCTA={buttonCTA}
                    onSubmit={this._handleSubmit}
                    clearAuthNotification={clearAuthNotification}
                    locale={locale}
                    recaptcha2PublicKey={recaptcha2PublicKey}
                    showCaptcha={showCaptcha}
                    fp={fp}
                    showNotification={this._handleShowNotification}
                    clearNotification={this._handleClearNotification}
                />
            </SplitContainer>
        );
    }
}

export default withMainControls(ResetPasswordPage);
